<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12">
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>Set Password</v-toolbar-title>
                    </v-toolbar>
                    <v-form v-if="!error" v-model="isFormValid">
                        <v-card-text>
                            <v-text-field v-model="password"
                                          :append-icon="show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                                          :rules="[rules.required, rules.min, rules.max]"
                                          :type="show ? 'text' : 'password'"
                                          label="Enter New Password"
                                          hint="At least 8 characters"
                                          counter
                                          @click:append="show = !show"></v-text-field>
                            <v-text-field v-model="rePassword"
                                          :append-icon="show1 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                                          :rules="[rules.required, rules.min, rules.max, passwordConfirmationRule]"
                                          :type="show1 ? 'text' : 'password'"
                                          label="Re-enter New Password"
                                          hint="At least 8 characters"
                                          counter
                                          @click:append="show1 = !show1"></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn @click="changePassword" :disabled="!isFormValid">Submit</v-btn>
                        </v-card-actions>
                    </v-form>
                    <v-form v-if="error">
                        <v-card-text>{{this.errorMessage}}</v-card-text>
                        <v-card-actions>
                            <v-btn @click="forgotPassword">Forgot Password</v-btn>
                            <v-spacer />
                            <v-btn @click="login">Login</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios'
    export default {
        data() {
            return {
                show: false,
                show1: false,
                password: "",
                rePassword: "",
                error: false,
                errorMessage: null,
                isFormValid: false,
                rules: {
                    required: value => !!value || "Required.",
                    min: v => v.length >= 8 || "Min 8 characters",
                    max: v => v.length <= 50 || "Max 50 characters",
                }
            };
        },

        methods: {
            async changePassword() {
                let response = null;
                try {
                    var urlArray = this.$route.fullPath.split("=");
                    var body = { Token: urlArray[1], NewPassword: this.password };
                    response = await axios.post('api/Security/ResetPassword', body);
                }
                catch (error) {
                    this.error = true;
                    if (error.response.status === 400) {
                        this.errorMessage = error.response.data;
                    }
                    else {
                        this.errorMessage = 'An internal server error has occured';
                    }
                    return;
                }
                const { dispatch } = this.$store;
                dispatch('authentication/setPasswordSuccuss', response.data);

                this.$router.push("/");
            },
            login() {
                this.$router.push("/login");
            },
            forgotPassword() {
                this.$router.push('/request-reset-password');
            },
        },

        computed: {
            passwordConfirmationRule() {
                return this.password === this.rePassword || "Password must match";
            }
        }
    };
</script>
